module.exports = __webpack_public_path__ + "img/guide-safari@3x.be5985ab.jpg";